export const fileField = (file: File | string | null, previousFile: string | undefined | null, key: string) =>
  (file instanceof File || (previousFile && typeof previousFile === 'string')) && {
    [key]: file,
  };

const allowedFileExtensions = ['jpg', 'jpeg', 'png', 'gif'];

const isValidExtension = (value: string) => allowedFileExtensions.some(extension => value.endsWith(`.${extension}`));

export const validateImg = (value: File | string) => {
  const fileName = value instanceof File ? value.name : value;

  if (fileName && !isValidExtension(fileName)) {
    return `Only .${allowedFileExtensions.join(', .')} files are accepted`;
  }

  return undefined;
};
